import { render } from "./search-overlay.vue?vue&type=template&id=21863e6a&scoped=true"
import script from "./search-overlay.vue?vue&type=script&lang=js"
export * from "./search-overlay.vue?vue&type=script&lang=js"

import "./search-overlay.vue?vue&type=style&index=0&id=21863e6a&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21863e6a"]])

export default __exports__